/* Compact alignment per visible row: break after pipe, do not reserve arbitrary extra lines. */
(() => {
 let frame = null;
 function apply() {
  document.querySelectorAll('.collection .product-grid').forEach(grid => {
   const items = [...grid.children].filter(el => el.matches('li.grid__item') && el.getClientRects().length);
   const groups = new Map();
   items.forEach(item => {
    const link = item.querySelector('.product-card-wrapper .card > .card__content > .card__information > .card__heading a.full-unstyled-link');
    const heading = item.querySelector('.product-card-wrapper .card > .card__content > .card__information > .card__heading');
    if (!heading || !link) return;
    if(!link.dataset.smartfulLineBreak) {
      const title = link.textContent.trim();
      const index = title.indexOf('|');
      if(index !== -1) {
       const first = document.createElement('span'), second=document.createElement('span');
       first.className = 'smartful-title-line';
       second.className = 'smartful-title-line';
       first.textContent = title.slice(0,index+1).trim();
       second.textContent = title.slice(index+1).trim();
       link.replaceChildren(first, second);
      }
      link.dataset.smartfulLineBreak='1';
    }
    heading.style.minHeight = '';
    const top = Math.round(item.getBoundingClientRect().top);
    if(!groups.has(top))groups.set(top,[]);
    groups.get(top).push(heading);
   });
   groups.forEach(headings=>{
    const max = Math.ceil(Math.max(...headings.map(h=>h.getBoundingClientRect().height)));
    headings.forEach(h=>{h.style.minHeight = max+'px';});
   });
  });
 }
 function schedule(){
  if(frame!==null)return;
  frame=requestAnimationFrame(()=>{frame=null;apply();});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);
 else schedule();
 window.addEventListener('resize',schedule,{passive:true});
 new MutationObserver(mutations=>{
  if(mutations.some(m=>[...m.addedNodes].some(n=>n.nodeType===1 && (n.matches?.('.product-grid')||n.querySelector?.('.product-grid')))))schedule();
 }).observe(document.documentElement,{childList:true,subtree:true});
})();
